import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'estadoMayor'
})
export class EstadoMayorPipe implements PipeTransform {

  transform(items: any[], min:number,max:number): any {
    if(!items) return []
    if(!min) return items

    return items.filter(item=>{ 
      //console.log("id",item.id,">=",min,"&& item <=",max)
      return item.id >= min && item.id <= max 
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/filters/estado-mayor.pipe.ts